import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { handleBuyClick } from './utils/metaPixel';
export const OfferBlock = () => {
  return <section id="oferta" className="py-24 bg-dark relative overflow-hidden scroll-mt-16" data-id="element-147">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-neon/10 rounded-full blur-[100px] pointer-events-none" data-id="element-148" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-149">
        {/* Price card with image */}
        <FadeIn data-id="element-150">
          <div className="bg-dark-card border border-neon/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(163,255,18,0.1)] mb-12" data-id="element-151">
            <div className="flex flex-col lg:flex-row items-center gap-10" data-id="element-152">
              {/* Image */}
              <div className="flex-1 w-full max-w-xs lg:max-w-none" data-id="element-153">
                <img src="https://cdn.magicpatterns.com/uploads/i98tbdWAFmDMydmCtG4nes/efectivo_inmediato_48_horas.png" alt="Plan de 48 Horas — Ebook PDF" className="w-full h-auto drop-shadow-2xl" data-id="element-154" />
              </div>

              {/* Content */}
              <div className="flex-1 text-center lg:text-left w-full" data-id="element-155">
                <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-156">
                  El plan completo por solo{' '}
                  <span className="text-neon" data-id="element-157">6.39 dólares</span>
                </h2>
                <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans mb-6" data-id="element-158">
                  PDF de 20 páginas. Descarga inmediata. Garantía de 7 días.
                </p>

                <div className="mb-2 flex items-baseline gap-3 justify-center lg:justify-start" data-id="element-159">
                  <span className="text-6xl md:text-7xl text-neon font-display drop-shadow-[0_0_15px_rgba(163,255,18,0.5)]" data-id="element-160">
                    6.39
                  </span>
                  <span className="text-2xl text-white" data-id="element-161">dólares</span>
                </div>
                <p className="text-sm text-gray-500 font-sans" data-id="element-162">
                  Pago único · Acceso de por vida
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Final CTA */}
        <FadeIn delay={0.2} data-id="element-163">
          <div id="cta-final" className="flex flex-col items-center gap-4 scroll-mt-24" data-id="element-164">
            <Button className="w-full sm:w-auto py-5 text-lg md:text-xl" showIcon={false} onClick={handleBuyClick} data-id="element-165">
              ⚡ QUIERO EL PLAN DE 48 HORAS — 6.39 dólares
            </Button>

            <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm text-gray-400 mt-2 max-w-2xl" data-id="element-166">
              <span data-id="element-167">✓ Acceso instantáneo</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-168" />
              <span data-id="element-169">✓ Pago seguro</span>
              <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-170" />
              <span data-id="element-171">✓ Descarga inmediata en PDF</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};